import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, makeStyles } from '@material-ui/core';
import Body from './body';
import Header from './header';
import CustomButton from '../customButton';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  table: {
    display: 'grid',
  },
  loadMoreWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: spacing(4),
    width: '100%',
  },
  loadMoreButton: {
    border: `1px solid ${primary.bluish3}`,
    borderRadius: 44,
    color: primary.bluish4,
    lineHeight: '24px',
    justifySelf: 'center',
    padding: spacing(1, 4),
    maxHeight: 32,
  },
}));

const CollapsableTable = ({
  className = undefined,
  headerClass = undefined,
  translations,
  headerActions = {},
  columns,
  rows,
  detailsComponent,
  detailsComponentProps = {},
  hasLoadMore,
  onGetRowDetails,
  onLoadMore,
}) => {
  const classes = useStyles();

  const headers = [...columns, ...headerActions];

  return (
    <div className={classNames(classes.root, className)}>
      <Header className={headerClass} columns={headers} />
      <Body
        translations={translations}
        columns={headers}
        rows={rows}
        detailsComponent={detailsComponent}
        detailsComponentProps={detailsComponentProps}
        onGetRowDetails={onGetRowDetails}
      />
      <Fade in={hasLoadMore} unmountOnExit>
        <div className={classes.loadMoreWrapper}>
          <CustomButton
            type="addWithTextRounded"
            className={classes.loadMoreButton}
            onClick={onLoadMore}
          >
            {translations.loadMoreLabel}
          </CustomButton>
        </div>
      </Fade>
    </div>
  );
};

CollapsableTable.propTypes = {
  className: PropTypes.string,
  headerClass: PropTypes.string,
  translations: PropTypes.object.isRequired,
  headerActions: PropTypes.arrayOf(PropTypes.shape({})),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  detailsComponent: PropTypes.elementType.isRequired,
  detailsComponentProps: PropTypes.object,
  hasLoadMore: PropTypes.bool.isRequired,
  onGetRowDetails: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
};

export default CollapsableTable;
